<template>
  <div id="bitWind-content">
    <div id="bitWind-page">
      <div class="block-item block-item1">
        <div class="content-bg">
          <div class="block-content">
            <h2 class="block-title">BitWind加密货币流动性提供系统</h2>
            <p class="market text">在为广大中小交易所提供流动性，实现运营价值和资产价值的双重收获</p>
            <a href="https://www.chainup.com/zh-CN/form?form=bitWind" target="_blank" class="blue-button">
              <span>开始演示</span>
            </a>
          </div>
        </div>
      </div>
      <div class="block-item block-item2">
        <div class="block-content">
          <h2 class="block-title">BitWind工作原理</h2>
          <p class="b-x"></p>
          <p class="text">
            聚合来自全球头部交易所、ChainUP生态交易所等超过200家加密货币交易所的买卖深度，提供最优的报价、最低的点差和最好的流动性
          </p>
          <div class="yl-img">
            <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/2_image_center.png" alt="" />
            <span class="text-1">加密货币交易所</span>
            <span class="text-2">加密货币券商</span>
            <span class="text-3">机构投资者</span>
            <span class="text-4">ChainUP生态交易所</span>
            <span class="text-5">头部交易所</span>
            <span class="text-6">更多</span>
          </div>
        </div>
      </div>
      <div class="block-item block-item3">
        <div class="block-content">
          <div class="container-bar clearfix">
            <div class="s-img">
              <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/3_image_left.png" alt="" />
            </div>
            <div class="info">
              <h2 class="block-title">阶梯式交易费率</h2>
              <p class="b-x"></p>
              <p class="text">
                系统根据客户每月实际对冲量，调整交易手续费；对冲量大的客户可以享受业界最大手续费进行交易，从而降低对冲成本。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-item block-item4">
        <div class="block-content">
          <div class="container-bar clearfix">
            <div class="s-img">
              <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/4_image_right.png" alt="" />
            </div>
            <div class="info">
              <h2 class="block-title">3-5 倍现货杠杆配资</h2>
              <p class="b-x"></p>
              <p class="text">
                支持现货杠杆，可授信 3-5 倍配资，无需占用大量资产，便可享受专业的流动性服务
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-item block-item5">
        <div class="block-content">
          <h2 class="block-title">产品服务</h2>
          <p class="b-x"></p>
          <div class="product-list">
            <ul class="clearfix">
              <li>
                <div class="p-img">
                  <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/5_icon_1.png" alt="" />
                </div>
                <div class="text-info">
                  <h4>市场深度优</h4>
                  <p class="text">BitWind拥有全球最大的加密货币流动性池，可为客户提供顶级的市场深度服务</p>
                </div>
              </li>
              <li>
                <div class="p-img">
                  <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/5_icon_2.png" alt="" />
                </div>
                <div class="text-info">
                  <h4>稳定性高</h4>
                  <p class="text">专业的金融、证券、期货级投资交易网络架构</p>
                </div>
              </li>
              <li>
                <div class="p-img">
                  <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/5_icon_3.png" alt="" />
                </div>
                <div class="text-info">
                  <h4>交易类型全</h4>
                  <p class="text">提供币币交易、合约交易、场外交易流动性解决方案</p>
                </div>
              </li>
              <li>
                <div class="p-img">
                  <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/5_icon_4.png" alt="" />
                </div>
                <div class="text-info">
                  <h4>对冲策略专业</h4>
                  <p class="text">专业化对冲策略，交易所可管理自己的头寸</p>
                </div>
              </li>
              <li>
                <div class="p-img">
                  <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/5_icon_5.png" alt="" />
                </div>
                <div class="text-info">
                  <h4>支持币对多</h4>
                  <p class="text">开放了近 100 个主流交易币对、热门币种 ，对接50+的公链，采用冷热钱包和强大的风控体系保证资金安全</p>
                </div>
              </li>
              <li>
                <div class="p-img">
                  <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/5_icon_6.png" alt="" />
                </div>
                <div class="text-info">
                  <h4>成交低时延</h4>
                  <p class="text">使用专线网络部署报价聚合器来对接的各大交易所，可获得最快的报价和超低订单延时</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="block-item block-item6">
        <div class="content-bg">
          <div class="block-content">
            <h2 class="block-title">适用客户</h2>
            <p class="b-x"></p>
            <div class="customer-list">
              <div class="item">
                <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/6_icon_1.png" alt="" />
                <h4>加密货币交易所</h4>
                <p class="text">解决中小型交易所流动性不足，盘口深度差，客户交易体验差等问题</p>
              </div>
              <div class="item">
                <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/6_icon_2.png" alt="" />
                <h4>加密货币券商</h4>
                <p class="text">提供最优的报价和深度，更快的对冲交易体验</p>
              </div>
              <div class="item">
                <img src="http://chaindown-oss.oss-cn-hongkong.aliyuncs.com/static/bitWind/6_icon_3.png" alt="" />
                <h4>机构投资者</h4>
                <p class="text">减小交易成本，实现更多盈利</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="block-item block-item7">
        <div class="footer-left-block">
          <div class="f-logo">
            <img src="https://saas-oss.oss-cn-hongkong.aliyuncs.com/upload/20190808182414620.png" alt="">
          </div>
          <p>Copyright © 2019 BitWind.com </p>
          <p>bitwind@service.com</p>
        </div>
        <div class="bitWind-footer-template">
          <ul class="menu-ul-bitWind">
            <!-- <li class="tit">政策</li> -->
            <li class="item">
              <a href="/cms/aboutus" class="">
                <span>关于我们</span>
              </a>
            </li>
            <li class="item">
              <a href="/cms/declaration" class="">
                <span>法律声明</span>
              </a>
            </li>
          </ul>
          <ul class="menu-ul-bitWind">
            <!-- <li class="tit">支持</li> -->
            <li class="item">
              <a href="/cms/agreement" class="">
                <span>用户协议</span>
              </a>
            </li>
            <li class="item">
              <a href="/cms/app" class="">
                <span>APP下载</span>
              </a>
            </li>
            <li class="item">
              <a href="https://github.com/exchange-doc/api/tree/master/hiex" target="_blank" class="">
                <span>API文档</span>
              </a>
            </li>
          </ul>
          <ul class="menu-ul-bitWind">
            <!-- <li class="tit">关于</li> -->
            <li class="item">
              <a href="/cms/privacy_policy" class="">
                <span>隐私条款</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="page-nav">
      <ul id="page-ul" class="page-ul">
        <li id="0" class="nav-item nav-item-1">关于BitWind</li>
        <li id="1" class="nav-item nav-item-2">工作原理</li>
        <li id="2" class="nav-item nav-item-3">阶梯式交易费率</li>
        <li id="3" class="nav-item nav-item-4">现货杠杆配资</li>
        <li id="4" class="nav-item nav-item-5">产品服务</li>
        <li id="5" class="nav-item nav-item-6">适用客户</li>
      </ul>
    </div>
  </div>
</template>

<script>
const bitWindHomeFuncton = function bitWindHome() {
  const offsetheight = document.documentElement.clientHeight; // 获取当前页面的高度、
  const small = offsetheight <= 800;
  const $container = document.getElementById('bitWind-content');
  const $page = document.getElementById('bitWind-page');
  const $blockItem = document.getElementsByClassName('block-item');
  const $navItem = document.getElementsByClassName('nav-item');
  const $app = document.getElementById('app');
  const $pageUl = document.getElementById('page-ul');

  let fullPage = 0; // 当前在第几页
  let fullPageNum = false; // 是否在滑动

  if ($pageUl && small) {
    $pageUl.style.height = `${offsetheight - 100}px`;
  }
  if ($container && !small) {
    $container.style.height = `${offsetheight}px`;
  }
  if ($blockItem && $blockItem.length) {
    for (let i = $blockItem.length - 1; i >= 0; i -= 1) {
      $blockItem[i].style.height = `${offsetheight}px`;
    }
  }
  // 设置第一个为选中状态
  if ($navItem[fullPage]) $navItem[fullPage].classList.add('active');
  const setNavClass = () => {
    if ($navItem && $navItem.length) {
      for (let i = $navItem.length - 1; i >= 0; i -= 1) {
        $navItem[i].classList.remove('active');
        if (fullPage < 6) {
          $navItem[fullPage].classList.add('active');
        }
        if (fullPage === 6) {
          $app.classList.add('app-block-item7');
        } else {
          $app.classList.remove('app-block-item7');
        }
      }
    }
  };
  const setPage = () => {
    setNavClass();
    $page.style.transform = `translate3d(0px,-${fullPage * offsetheight}px, 0px)`;
  };
  const scroll = (e) => {
    const even = e || window.event;
    if (!fullPageNum) {
      if (even.wheelDelta < -10 && fullPage < $blockItem.length - 1) {
        fullPage += 1;
        fullPageNum = true;
        setPage();
        setTimeout(() => {
          fullPageNum = false;
        }, 1200);
      }
      if (even.wheelDelta > 10 && fullPage > 0) {
        fullPage -= 1;
        fullPageNum = true;
        setPage();
        setTimeout(() => {
          fullPageNum = false;
        }, 1200);
      }
    }
  };
  const clickPage = () => {
    if ($pageUl) {
      $pageUl.onclick = function navclck(e) {
        const index = parseInt(e.target.id, 0);
        if (small) {
          const navList = document.querySelector('#page-ul').querySelectorAll('.nav-item');
          document.querySelector('#bitWind-page').querySelectorAll('.block-item')[index].scrollIntoView();
          for (let i = 0, len = navList.length; i < len; i += 1) {
            navList[i].classList.remove('active');
          }
          navList[index].classList.add('active');
        } else {
          document.querySelector('#page-ul').querySelectorAll('.nav-item');
          fullPage = index;
          setPage();
        }
      };
    }
  };
  clickPage();
  if (!small) {
    if (document.addEventListener) {
      document.addEventListener('DOMMouseScroll', scroll, false);
    }
    document.onmousewheel = scroll;
    window.onmousewheel = document.onmousewheel;
  }
};
window.bitWindHomeFuncton = bitWindHomeFuncton;
</script>
<style
 src="BlockChain-ui-privatization/PC/common-mixin/home/custom/bitWind/bitWind.styl" lang="stylus">
</style>
